import React from 'react'
import { TbCategory } from 'react-icons/tb'
import './CourseCategoryItem.css'
export default function CourseCategoryItem({ backgroundColor, item }) {
    return (
        <div className='course-category-item'>
            <div className='course-category-icon' style={{ backgroundImage: backgroundColor }}>
                    <TbCategory />
            </div>
            <div className='course-category-title'>
                {item.title}
                <div className='course-count'>
                    +{item.courses.length} دوره
                </div>
            </div>
        </div>
    )
}
